import styled from "styled-components"

const ActuTaxo = styled.p`
  color: ${(props) => props.theme.a_color_gradients.a_dark};
  margin-right: 1rem;
  margin-bottom: 0;
`

export { ActuTaxo }
